var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36517 6.91075C4.69061 6.58531 5.21825 6.58531 5.54368 6.91075L10.7878 12.1548L16.0318 6.91075C16.3573 6.58531 16.8849 6.58531 17.2103 6.91075C17.5358 7.23618 17.5358 7.76382 17.2103 8.08926L11.377 13.9226C11.0516 14.248 10.5239 14.248 10.1985 13.9226L4.36517 8.08926C4.03973 7.76382 4.03973 7.23618 4.36517 6.91075Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrOff);
export default __webpack_public_path__ + "static/media/down_arr_off.0849af43e1fefb1203070d428298fab7.svg";
export { ForwardRef as ReactComponent };